// frontend/src/pages/daily-tug-report/required.js
// What a section must carry before it can be submitted — the same rules as
// backend/src/modules/dtr/dtr.required.js, checked here first so a report filled
// in offline is never queued only to be refused later. A best guess pending UAT.
export const VARIANCE_REMARK_ABOVE_L = 50;

const ME = [['Assist', 'Assist'], ['FreeRun', 'Free run'], ['Shifting', 'Shifting'], ['Towing', 'Towing'], ['SeaTrial', 'Sea trial']];
const AE = [['1', 'A/E No.1'], ['2', 'A/E No.2'], ['3', 'A/E No.3'], ['FireMonitor', 'Fire monitor']];
const blank = (v) => v === null || v === undefined || (typeof v === 'string' && v.trim() === '');
const positive = (v) => Number(v) > 0;

export function deckProblems(d) {
  const out = [];
  if (blank(d.portId)) out.push('Port');
  if (blank(d.weather)) out.push('Weather');
  if (blank(d.seaCondition)) out.push('Sea condition');
  if (blank(d.locationNote)) out.push('Location / status');
  if (blank(d.latitude) !== blank(d.longitude)) out.push('Latitude and longitude together, or neither');
  if (d.operational === false && blank(d.deckRemarks)) out.push('Deck remarks saying why the tug is not operational');
  return out;
}

/** `totals` is the page's live totals ({ sounded, variance }). */
export function engineProblems(e, totals) {
  const out = [];
  if (blank(e.fuelOpeningL)) out.push('Fuel on board yesterday');
  if (totals.sounded == null) out.push('Fuel sounded today');
  for (const t of e.tankSoundings || []) if (blank(t.litres)) out.push(`Sounding for tank ${t.tank || '(unnamed)'}`);
  if (blank(e.freshWaterT)) out.push('Fresh water');
  const pair = (hours, fuel, label) => {
    if (positive(hours) !== positive(fuel)) out.push(`${label}: hours and fuel must both be entered`);
  };
  for (const [k, l] of ME) pair(e[`meHours${k}`], e[`meFuel${k}`], `Main engine ${l}`);
  for (const [k, l] of AE) pair(e[`aeHours${k}`], e[`aeFuel${k}`], l);
  if (positive(e.fuelSuppliedL) && blank(e.fuelSuppliedBy)) out.push('Supplier of the fuel supplied');
  if (positive(e.fuelFromTugsL) && blank(e.fuelFromTugName)) out.push('Which tug the fuel came from');
  if (positive(e.fuelTransferredL) && blank(e.fuelTransferredTo)) out.push('Who the fuel was transferred to');
  if (totals.variance != null && Math.abs(totals.variance) > VARIANCE_REMARK_ABOVE_L && blank(e.engineRemarks)) {
    const what = totals.variance < 0 ? `${-totals.variance} L shortage` : `${totals.variance} L excess`;
    out.push(`Engine remarks explaining the ${what}`);
  }
  return out;
}
